import React from "react";
import { Chip, Zoom } from "@mui/material";

export const AnimatedChip = ({ card, index, handleCardClick }) => {
  const timeout = 500 + index * 200; // Adjust the timing as needed

  return (
    <Zoom in={true} timeout={timeout}>
      <Chip
        key={index}
        color="success"
        onClick={() => handleCardClick(card)}
        size="small"
        variant="outlined"
        sx={{
          m: 0.3, // Reduced margin to make chips closer
          ml: 2,
          px: 0.8, // Reduced horizontal padding
          py: 0.3, // Reduced vertical padding
          fontSize: "0.75rem", // Slightly smaller text
          cursor: "pointer",
          transition: "transform 0.2s",
          "&:hover": { transform: "scale(1.05)" },
        }}
        label={card.title}
      />
    </Zoom>
  );
};
